import { render } from "./HomeActivacion.vue?vue&type=template&id=30236246&scoped=true"
import script from "./HomeActivacion.vue?vue&type=script&lang=js"
export * from "./HomeActivacion.vue?vue&type=script&lang=js"

import "./HomeActivacion.vue?vue&type=style&index=0&id=30236246&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30236246"]])

export default __exports__